// NPM Imports
import React, { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "../../revvComponents";
import ShowconvertFormDocToEditorDoc from "../DocumentV2/ShowconvertFormDocToEditorDoc/ShowconvertFormDocToEditorDoc";

import { convertFormDocToEditorDoc } from "../../actions/DocumentActions";

function CustomizeDocBtn(props) {
  const [showconvertFormDocToEditorDoc, updateShowconvertFormDocToEditorDoc] =
    useState(false);

  // * CALL ACTIONS USING THIS ALIAS
  const dispatch = useDispatch();

  const docID = useSelector(state => state.DocumentStore.document.id);
  const showForm = useSelector(state => state.DocumentStore.document.showForm);
  const docStage = useSelector(state => state.DocumentStore.document.stage);
  const docType = useSelector(state => state.DocumentStore.document.docType);

  const showEditFormDocBtn =
    showForm &&
    docStage === "DRAFT" &&
    docType !== "master_form" &&
    !props.isSharedDocument;

  if (!showEditFormDocBtn) return "";

  const toggleModalPopUp = () => {
    updateShowconvertFormDocToEditorDoc(false);
  };
  const convertFormModeDocToEditor = () => {
    if (docID) {
      dispatch(convertFormDocToEditorDoc(docID));
    } else {
      console.debug("docID is undefined in CustomizeDocBtn");
    }
  };

  const tooltipText =
    "Customizing this document will let you add more content and style.";

  return (
    <Fragment>
      {showconvertFormDocToEditorDoc && (
        <ShowconvertFormDocToEditorDoc
          toggleModalPopUp={toggleModalPopUp}
          confirmAction={convertFormModeDocToEditor}
        />
      )}
      <div className="edit-form-mode-doc remove-from-export">
        <Tooltip
          placement="bottom"
          align={{
            offset: [0, 4],
          }}
          overlay={tooltipText}>
          <Button
            type="five"
            className="revvBtn_container edit-form-mode-doc-btn remove-from-export"
            onClick={() => {
              updateShowconvertFormDocToEditorDoc(true);
            }}
            data-test="edit-form-mode-doc-btn">
            <i>
              <FontAwesomeIcon icon={["far", "edit"]} />
            </i>
            Customize document
          </Button>
        </Tooltip>
      </div>
    </Fragment>
  );
}

export default CustomizeDocBtn;
